/**
 * 功能权限控制
 */
import { makeAutoObservable, runInAction } from 'mobx'
import AuthConfigApi from '@api/authConfig.api'
import { concat, keyBy } from '@dt/fe-utils/dist/lodash'

class AuthConfigMobx {
  constructor () {
    makeAutoObservable(this)
  }
  authList: IListByKeys[] = []
  authListByKey: { [key: string]: IListByKeys } = {}

  async init (key: string) {
    if (this.authListByKey[key]) {
      return true
    } else {
      try {
        const { result } = await AuthConfigApi.getListByKeys({
          app: 'moduleStage',
          keys: [key]
        })
        if (result?.content?.length) {
          let _list = [...result?.content]
          let _listKey = keyBy(_list, 'key')
          runInAction(() => {
            this.authList = concat(this.authList, [...result?.content])
            this.authListByKey = { ...this.authListByKey, ..._listKey }
          })
          return true
        }
      } catch (error) {
      }
      return false
    }
  }

  get isNoWorry () {
    const obj = this.authListByKey.noWorry
    if (obj) {
      return obj.key === 'noWorry' && (obj.bo.includes(window.bo) || obj.brandIds.includes(Config.BRANDID))
    }
    return true
  }
}

export default new AuthConfigMobx()
